import { connect } from "react-redux";
import DocumentViewBase from "../components/DocumentView/DocumentViewBase";

const mapStateToProps = (state) => ({
  user: state.login.user,
  menuData: state.menu.menuData,
});

export default connect(mapStateToProps)(DocumentViewBase);
